<template>
  <form @submit.prevent>
    <a v-if="!addingProject" class="form-action-text text-secondary white-space-nowrap"
      @click="addProject"
    >
      + Add Project
    </a>
    <template v-if="addingProject">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">Project ID</div>
        </div>
        <input class="form-control"
          name="projectId"
          placeholder="Enter Project ID Number"
          v-model="projectId"
          v-validate="'required|numeric|excluded:' + existingProjectIdCsv + '|project_exists'"
          data-vv-as="Project ID"
          maxlength="10">
        <div class="input-group-append">
          <b-button @click="getProperties(projectId)"
            class="rounded-right">Get Properties</b-button>
        </div>
        <a class="form-action-icon text-danger"
          @click='projectAdded'
        >
          <font-awesome-icon icon='trash-alt' />
        </a>
      </div>
      <div v-if="errors.first('projectId')" class="invalid-feedback d-block mb-2">
        {{ errors.first('projectId') }}
      </div>
    </template>
  </form>
</template>

<script>
import api from '../api';

export default {
  name: 'GetProperties',
  props: ['projects', 'serviceId'],
  data() {
    return {
      projectId: null,
      addingProject: false,
    };
  },
  computed: {
    existingProjectIdCsv() {
      return this.projects.map(project => project.id).join(',');
    },
  },
  methods: {
    getProperties(projectId) {
      this.$validator.validate()
        .then((result) => {
          if (result) {
            if (this.serviceId === null || this.serviceId === undefined) {
              api.get(`/project/${projectId}/currentproperties`)
                .then((response) => {
                  this.$emit('projectAdded', { id: projectId, properties: response.data });
                  this.projectAdded();
                });
            } else {
              api.get(`/project/${projectId}/getvalidpropertiesbyservice/${this.serviceId}`)
                .then((response) => {
                  this.$emit('projectAdded', { id: projectId, properties: response.data });
                  this.projectAdded();
                });
            }
          }
        });
    },
    addProject() {
      this.addingProject = true;
    },
    projectAdded() {
      this.projectId = null;
      this.$validator.reset().then(() => { this.addingProject = false; });
    },
  },
};
</script>
